export enum EMsgUserType {
    Client = 0,
    Doctor = 1,
    Admin = 2
}